const countries = window.allCountries;

const threeLetterCurrencies = countries
    .filter(c => Boolean(c.isThreeLetterCurrency))
    ?.map(c => c.alfa);


const createCountriesObjByKey = (tKey, valKey) => {
    return countries.reduce((acc, val) => {
        acc[val[tKey]] = val[valKey];
        return acc
    }, {});
}

export const localizedCountries = createCountriesObjByKey('alfa', 'name');

export const countriesPhonePlaceholders = createCountriesObjByKey('alfa', 'phone_placeholder');

export function getCountryCode(numberCode) {
    return countries.find(c => {
        return c.id.toString() === numberCode.toString()
    })?.alfa || '';
}

export function getCountryId(isoCode) {
    return countries.find(({alfa}) => alfa === isoCode)?.id
}

export const isThreeLetterCurrencySymbol = code => {
    return countries
        .filter(c => threeLetterCurrencies.some(th => th === c.alfa))
        .some(c => c.currency === code)
}

export function getCountryCurrency(countryCode) {
    return countries.find(c => {
        return c.id == countryCode || c.alfa == countryCode
    })?.currency || '';
}
